var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessMarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#D1FADF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#ECFDF3",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6666 31.9262V32.9995C44.6652 35.5153 43.8505 37.9633 42.3441 39.9783C40.8378 41.9933 38.7204 43.4674 36.3078 44.1807C33.8953 44.8941 31.3167 44.8084 28.9568 43.9365C26.5969 43.0647 24.582 41.4533 23.2127 39.3428C21.8434 37.2322 21.193 34.7356 21.3585 32.2252C21.5241 29.7148 22.4967 27.3252 24.1312 25.4128C25.7658 23.5003 27.9748 22.1675 30.4288 21.613C32.8828 21.0586 35.4502 21.3122 37.7483 22.3362M44.6666 23.6662L32.9999 35.3445L29.4999 31.8445",
    stroke: "#039855",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMarkIcon);
export default __webpack_public_path__ + "static/media/successMarkIcon.0da54915c98ad3bfee459ed6950ff7bc.svg";
export { ForwardRef as ReactComponent };